const STORAGE_FILTER_KEY_DEFAULT = 'productFilters'
const STORAGE_SORT_KEY_DEFAULT = 'productSort'
function getDefaultFilters () {
  return {
    judgmentStatus: ['審査中', '出品中', '停止中', '審査NG', '出品NG'],
    stockStatus: ['in', 'out'],
    warehouse: ['Amazon', 'salmonAcross', 'salmonSc'],
    amountReceived: false
  }
}

function loadFiltersFromStorage (key) {
  try {
    const data = JSON.parse(localStorage.getItem(key))
    if (data && (!Array.isArray(data.judgmentStatus) || !Array.isArray(data.stockStatus))) {
      return getDefaultFilters()
    }
    return data || getDefaultFilters()
  } catch (e) {
    return getDefaultFilters()
  }
}

function loadSortFromStorage (key) {
  try {
    const data = JSON.parse(localStorage.getItem(key))
    return data || 'parentAsin_asc'
  } catch (e) {
    return 'parentAsin_asc'
  }
}

const state = {
  saveFilters: getDefaultFilters(),
  saveSort: 'parentAsin_asc'
}

const mutations = {
  loadProductFilters (state, { storageKey = STORAGE_FILTER_KEY_DEFAULT } = {}) {
    state.saveFilters = loadFiltersFromStorage(storageKey)
  },
  resetProductFilters (state, { storageKey = STORAGE_FILTER_KEY_DEFAULT } = {}) {
    state.saveFilters = getDefaultFilters()
    localStorage.setItem(storageKey, JSON.stringify(state.saveFilters))
  },
  saveProductFilters (state, { data = {}, storageKey = STORAGE_FILTER_KEY_DEFAULT } = {}) {
    state.saveFilters = {
      ...state.saveFilters,
      ...data
    }
    localStorage.setItem(storageKey, JSON.stringify(state.saveFilters))
  },
  loadProductSort (state, { storageKey = STORAGE_SORT_KEY_DEFAULT } = {}) {
    state.saveSort = loadSortFromStorage(storageKey)
  },
  saveProductSort (state, { saveSort = '', storageKey = STORAGE_SORT_KEY_DEFAULT } = {}) {
    state.saveSort = saveSort
    localStorage.setItem(storageKey, JSON.stringify(state.saveSort))
  }
}

const getters = {
  getProductFilters: state => state.saveFilters,
  getProductSort: state => state.saveSort
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js